<template>
  <div
    class="m-3 overflow-auto"
    style="max-height: 180px; border: 1px solid #ddd"
  >
    <div class="m-2 d-flex align-items-center">
      <span class="description mx-4">{{ titulo }}</span>
    </div>

    <div
      class="mx-2"
      v-for="(institucion, index) in instituciones"
      :key="index"
    >
      <input
        type="checkbox"
        :id="`institucion-${institucion.id}`"
        :name = "name"
        :value="institucion.id"
        :checked="seleccionadasSafe.includes(institucion.id)"
        @change="toggleInstitucion(institucion.id)"
      />
      {{ institucion.nombre }}
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from "vue";

const props = defineProps({
  instituciones: Array,
  seleccionadas: Array,
  titulo: String,
  id: String,
  name: String,
});

const emit = defineEmits(["update:seleccionadas"]);

// Evitar errores asegurando que seleccionadas sea un array
const seleccionadasSafe = computed(() => props.seleccionadas || []);

const toggleInstitucion = (id) => {
  const nuevasSeleccionadas = [...seleccionadasSafe.value];
  const index = nuevasSeleccionadas.indexOf(id);

  if (index === -1) {
    nuevasSeleccionadas.push(id);
  } else {
    nuevasSeleccionadas.splice(index, 1);
  }

  emit("update:seleccionadas", nuevasSeleccionadas);
};
</script>
<style>
.description {
  font-size: 1.2em;
  color: rgba(255, 0, 0, 0.552);
}
</style>
